import { useQuery } from '@tanstack/react-query';
import { BreadcrumbGroup, Spinner } from '@cloudscape-design/components'; // Importing the Spinner component

import { EventsView } from './events';
import { getEvents } from '../../../common/api/events';
import { Loading } from '../../../components/Loading';
import { useNavigate } from 'react-router-dom';

export default function View() {
  const navigate = useNavigate();

  const getQuery = useQuery({
    queryKey: ['events'],
    queryFn: getEvents,
    enabled: true,
    staleTime: 0,
    gcTime: 0,
  });
  const events = getQuery.data;

  return (
    <div className="bg-[#101c2c] text-white font-sans p-4">
      <div className="mb-4">
        <BreadcrumbGroup
          items={[
            { text: 'Manage', href: '/manage' },
            { text: 'Events', href: '/manage/events' },
          ]}
          onFollow={(e) => {
            e.preventDefault();
            navigate(e.detail.href);
          }}
        />
      </div>
      {getQuery.isLoading || !getQuery.data || !events ? (
        <Loading />
      ) : (
        <EventsView events={events} />
      )}
    </div>
  );
}
